var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileEllipsisBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 438,
    viewBox: "0 0 390 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 61,
    r: 10,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 23,
    r: 17,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 5.5,
    r: 5.5,
    fill: "#391C99"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 332.5,
    r: 12.5,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 10
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 410.5,
    r: 5.5,
    fill: "#391C99"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.5,
    cy: 325.5,
    r: 8,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 420,
    r: 14,
    fill: "#FBBC05",
    stroke: "#391C99",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileEllipsisBg);
export default __webpack_public_path__ + "static/media/MobileEllipsisBG.255cb1768bd03433e69be46685b3ed22.svg";
export { ForwardRef as ReactComponent };